// eslint-disable-next-line
import React, { Fragment } from "react";
import "./App.css";

const MobileImage = ({ menuImage }) => {
  return (
    <div className="section section-padding menu-v2">
      <div className="container image-center-align">
        {menuImage?.map((item, index) => (
          <Fragment key={index}>
            <div
              key={item?._id}
              className="menu-item-image-wrap"
            >
              <img src={item?.image_url} alt="img" />
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default MobileImage;
